<script>
export default {
  props: [ 'mainTargetForThisWeek' ],
};
</script>

<template>
  <div v-if="mainTargetForThisWeek" id="main-target-container">
    <v-card variant="outlined" class="my-5">
      <v-card-title>
        <div class="text-body-1 text-wrap text-red-darken-3">
          <h3 class="mb-2">Main Target/Goals for This Week</h3>
          <p v-html="mainTargetForThisWeek"></p>
        </div>
      </v-card-title>
    </v-card>
  </div>
</template>

<style scoped lang="scss">
#main-target-container {
  @media screen and (min-width: 768px) {
    padding: 0 12px;
  }
  p {
    line-height: 28px;
    font-weight: bold;
    white-space: pre-line;
  }
}
</style>
